module.exports = __webpack_public_path__ + "static/media/Tier_4.0926b5d9.png";